<template>
	<div>

		<div class="row pg_sec pg_admin sec_certifications">
			<div class="col-12">

				<div class="row">
		      <div class="col-8 hd ace_sec_hd" aria-label="Experience">
		        <h2>Email Campaigns</h2>
		        <span class="hd_bdr"></span>
		      </div>
					<div class="col-4" style="text-align: right;">
						<b-link @click="navigateToCreateEmailCampaign()" class="btn">Create Email Campaign</b-link>
					</div>
				</div>

				<div class="row">
		      <div class="col-12 list_view ace_sec" aria-label="Certifications Chart">

		        <div class="data_tbl_container" v-if="emailCampaignList.length === 0">
		          <div class="no_result">No email campaigns found</div>
		        </div>

		        <div class="row result_row" v-for="(c, index) in emailCampaignList">

		          <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
		            <div class="thumbnail_container ace_sec">
		              <div class="thumbnail_img" v-if="c.thumbnailURI">
		                <img v-bind:src="c.thumbnailURI" alt="Img">
		              </div>
		              <div class="thumbnail" v-else>
		                <div class="txt_bx" :id="setTitleBoxWidth(c.name, 'thumb_' + index)" v-html="setTitleInitials(c.name)"></div>
		              </div>
		            </div>
		          </div>


		          <div class="col-xl-10 col-lg-10 col-md-10 col-sm-8 entity_detail_section" :class="updateTitleHeight(index)">
		            <div class="row">
		              <div class="col-10 title_row">
		                <span class="title ace_sec_txt" :id="'entityName_' + index" :aria-label="c.name">{{c.name}}</span>

		                <b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
		                  <div class="title_container">
		                    {{c.name}}
		                  </div>
		                </b-popover>
		                <div :id="'entityNameContainer_' + index" class="title_container_popup"></div>

		              </div>
									<div class="col-2 program_type_tag" style="margin-top: -8px;">
		      					<span class="tag ace_sec_txt" style="float: right; margin-right: 0px;">{{c.campaignId}}</span>
		      				</div>
								</div>

								<div class="row" style="margin-top: 4px;">
									<div class="col-12 ace_sec_txt">
		                <strong>Link: </strong> {{emailCampaignLink(c)}}
		              </div>
								</div>

								<div class="row" style="margin-top: 15px;">
									<div class="col-6 ace_sec_txt">
		                <strong class="desc_txt">{{c.clicks}}</strong> Clicked
		              </div>
		              <div class="col-6 description ace_sec_txt" :id="'entityDesc_' + index" style="text-align: right;">
										Created on: {{changeMillisToDate(c.lastUpdatedTime)}}
		              </div>
								</div>

								<div class="row" style="margin-top: 15px;">
		              <div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index" v-if="c.description">
		                 <span class="desc_txt">{{ c.description }}</span>
		              </div>
		              <div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this certification" v-else>
		                 No description added for this email campaign
		              </div>
		            </div>

		          </div>

		        </div>

		      </div>
				</div>

    	</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'emailCampaignList',
  props: ['uuid'],
  components: {
  },
  data: () => {
    return {
      showReport: false,
      emailCampaignList: [
      ]
    }
  },
  mounted () {
    this.loadEmailTemplatesList()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadEmailCampaignList'
    ]),
    navigateToCreateEmailCampaign () {
      return this.$router.push({ name: 'emailCampaignCreate', params: { uuid: this.uuid } })
    },
    changeMillisToDate (millis) {
      if (millis) {
        let date = new Date(millis)
        let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
        return months[date.getMonth()] + '/' + date.getDate() + '/' + date.getFullYear()
      }
      return 'N/A'
    },
    async loadEmailTemplatesList () {
      await this.loadInstitutionDetail(this.uuid)
      this.emailCampaignList = await this.loadEmailCampaignList()
    },
    emailCampaignLink (emailCampaignObj) {
      return window.location.origin + '/vue/#/signup?institutionId=' + this.institution.openId + '&campaignId=' + emailCampaignObj.campaignId
    },
    setTitleBoxWidth (entityTitle, entityId) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      if (getTitleInitials.length < 3) {
        $('#' + entityId).addClass('txt_bx_' + getTitleInitials.length)
      }
      return entityId
    },
    setTitleInitials (entityTitle) {
      let getTitleInitials = entityTitle.match(/\b(\w)/g)
      return getTitleInitials.join('')
    },
    updateTitleHeight (index) {
      let titleContainerHeight = $('#entityName_' + index).height()
      if (titleContainerHeight > 30) {
        $('#entityDesc_' + index).addClass('srt_desc')
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution
    })
  },
  watch: {
  }
}
</script>
<style>
.mt-2 {
  margin-top: 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/EmailCampaignList.vue